import React from "react";

export const NoCodesIcon: () => React.JSX.Element = () => {
  return (
    <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="96" height="96" rx="48" fill="#E9F3FF"/>
      <rect x="26" y="26" width="44" height="44" stroke="#3A76BA" strokeWidth="4" strokeDasharray="6 6"/>
    </svg>
  );
};
